import React from 'react'

import { Loader, ProgressBar } from '@fourthwall/components'

import * as S from './KlaviyoSyncJobActive.styled'

type Props = {
  status: {
    key: string
    progress: number
    total: number
  }[]
}

export const KlaviyoSyncJobActive = ({ status }: Props) => {
  return (
    <S.Container>
      <S.Header>
        <Loader size="small" />
        Syncing data...
      </S.Header>
      <S.StatusList>
        {status.map((item) => {
          const percentage = item.total > 0 ? (item.progress / item.total) * 100 : 0

          const isComplete = percentage === 100
          const isPending = item.total === 0

          return (
            <S.StatusItem key={item.key}>
              <S.StatusLabel>{item.key}</S.StatusLabel>
              {item.total > 0 ? (
                <ProgressBar value={percentage} max={100} />
              ) : (
                <ProgressBar value={0} max={100} />
              )}
              {isComplete && <S.ProgressText>Completed</S.ProgressText>}
              {isPending && (
                <S.PendingContainer>
                  <Loader size="small" /> pending...
                </S.PendingContainer>
              )}
              {!isComplete && !isPending && (
                <S.ProgressText>
                  {item.progress} / {item.total} ({Math.round(percentage)}%)
                </S.ProgressText>
              )}
            </S.StatusItem>
          )
        })}
      </S.StatusList>
    </S.Container>
  )
}
